
const CookiePolicy = () => {
    return (
        <div className="p-5">
            <h1 className="text-center my-5 fontSize48">Cookie Policy</h1>
            
            <h2 className="my-4">Cookies Settings</h2>
            <h3>General</h3>
            <p>
                This page contains a description of the cookies we use on WiserBee Web sites, including www.wiserbee.ca. 
                Most Web browsers enable you to manage cookies through your browser settings. To learn more about cookies, 
                including how to see what cookies have been set and how to manage and delete them, visit www.aboutcookies.org 
                or www.allaboutcookies.org. As our Web sites and offerings materially evolve, we will review and update this 
                Web page from time to time.
            </p>

            <h2 className="my-4">What are Cookies?</h2>
            <p>
                Cookies are small pieces of data placed on your web browser by the offerings you use or the Web sites you visit. 
                Directive 2009/136/EC (the "Cookies Directive"), which amends Directive 2002/58/EC, came into force in the 
                European Union (EU) on 25 May 2011. The Cookies Directive provides that "the storing of information or the 
                gaining of access to information already stored, in the terminal equipment of a subscriber or user is only 
                allowed on condition that the subscriber or user concerned has given his or her consent, having been provided 
                with clear and comprehensive information".
            </p>

            <h2 className="my-4">Cookies Used on WiserBee Web sites</h2>
            <p>
                When you visit a WiserBee Web site, you may encounter cookies described in the list below. Our lists are 
                grouped based on the International Chamber of Commerce (ICC) cookie guide, which identifies four categories 
                of cookies:
            </p>
            <ol>
                <li>Strictly necessary cookies</li>
                <li>Performance cookies</li>
                <li>Functionality cookies</li>
                <li>Targeting or advertising cookies</li>
            </ol>

            <h2 className="my-4">More Information on Google Analytics</h2>
            <p>
                We use Google Analytics to collect top level information about how visitors use certain WiserBee Web sites. 
                Google Analytics provides the information we need to improve the user experience and serve up the content 
                our visitors find most useful. The Google Analytics cookies store information about what pages people visit, 
                how long they are on the site, how they got there and what they click on. Information supplied by Google 
                Analytics helps us analyze site traffic to identify areas to improve in order to provide our visitors with 
                a better experience. No personal information (for example, names or addresses) is gathered or stored, so 
                this information cannot be used to identify individuals. For an overview of privacy at Google, click here. 
                To opt out of being tracked by Google Analytics across all websites visit 
                <a href="http://tools.google.com/dlpage/gaoptout">http://tools.google.com/dlpage/gaoptout</a>.
            </p>

            <h2 className="my-4">Links to Third Party Offerings and Web Sites</h2>
            <p>
                We may also link to third party offerings of Web sites that use cookies like the ones described above. 
                If you access another offering or Web site through a link that we have provided, the offering you are 
                accessing or the site you are visiting is responsible for providing you with information about how they 
                use cookies.
            </p>

            <h2 className="my-4">Questions</h2>
            <p>
                If you have any comments, questions or concerns about this Privacy Policy, the data that we collect from 
                you or how that data is being used, or to report suspected misuse of your information, please contact us 
                at Privacy@wiserbee.ca or write to us at:
            </p>
            <h5 className="font-bold">
                WiserBee Corporation<br />
                Attn: Privacy Officer<br />
                520 Caverhill Cres<br />
                Milton, ON L9T5K2<br />
                cc: Legal Department
            </h5>
        </div>
    );
};

export default CookiePolicy;